export const keys = {
    all: ["user-role-admin"],

    user: (userID: number) => [
        ...keys.all,
        "user", {
            userID
        }
    ],
    userLists: () => [
        ...keys.all,
        "users"
    ],
    userList: (organizationID: number | undefined) => [
        ...keys.userLists(),
        {
            organizationID
        }
    ],
    userMemberships: () => [
        ...keys.all,
        "user-memberships"
    ],
    userMembership: (userID: number) => [
        ...keys.userMemberships(),
        {
            userID
        }
    ],
    effectiveUserPermissionLists: () => [
        ...keys.all,
        "user-effective-permissions"
    ],
    effectiveUserPermissionList: (organizationID: number | undefined, userID: number) => [
        ...keys.effectiveUserPermissionLists(),
        {
            organizationID,
            userID
        }
    ],

    userNotificationDisable: (userID: number) => [
        ...keys.all,
        "user-notification-disable", {
            userID
        }
    ],
    userPermissionsReport: (organizationID: number,
        groupID: number) => [
            ...keys.all,
            "user-permissions-report", {
                organizationID,
                groupID
            }
    ],

    userListReport: (organizationID: number,
        groupID: number) => [
            ...keys.all,
            "user-list-report", {
                organizationID,
                groupID
            }
    ],
    userRecipients: (contextGroupID: number,
        userID: number) => [
        ...keys.all,
        "user-recipients", {
            contextGroupID,
            userID
        }
    ],
    
    role: (roleID: number) => [
        ...keys.all,
        "role", {
            roleID
        }
    ],
    roleLists: () => [
        ...keys.all,
        "roles"
    ],
    roleList: (organizationID: number | undefined) => [
        ...keys.roleLists(),
        {
            organizationID
        }
    ],
    roleMemberships: () => [
        ...keys.all,
        "role-memberships"
    ],
    roleMembership: (roleID: number) => [
        ...keys.roleMemberships(),
        {
            roleID
        }
    ],
    rolePermissionLists: () => [
        ...keys.all,
        "role-permissions"
    ],
    rolePermissionList: (organizationID: number | undefined, roleID: number) => [
        ...keys.rolePermissionLists(),
        {
            organizationID,
            roleID
        }
    ],

    effectiveRolePermissionLists: () => [
        ...keys.all,
        "role-effective-permissions"
    ],
    effectiveRolePermissionList: (organizationID: number | undefined, roleIDs: Array<number>) => [
        ...keys.effectiveRolePermissionLists(),
        {
            organizationID,
            roleIDs
        }
    ],

    userUsageHistories: () => [
        ...keys.all,
        "user-usage-histories"
    ],
    userUsageHistory: (userID: number, startDate: Date, endDate: Date) => [
        ...keys.userUsageHistories(),
        {
            userID,
            startDate,
            endDate
        }
    ],
    rolePermissionsReport: (organizationID: number,
        groupID: number) => [
            ...keys.all,
            "role-permissions-report", {
                organizationID,
                groupID
            }
        ],

};
